import NotFound from 'components/notFound/NotFound';
import { ShopLayout } from 'components/layouts';
import { NextPage } from 'next';

const Custom404: NextPage = () => {
  return (
    <ShopLayout title="404">
      <NotFound />
    </ShopLayout>
  );
};

export default Custom404;
